export const updateContact=(contactDetails)=>{
    return{type:"UPDATE_CONTACT" , contactDetails : contactDetails }
}